
  const __registry__ = require('../../../spiferack/client/index.js')
  'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Router = require('@npm/spiferack/router');
var React = require('react');
var styles = require('./list.css');
var Banner = require('../../components/banner/banner');

var DisableTfa = function (_React$PureComponent) {
  _inherits(DisableTfa, _React$PureComponent);

  function DisableTfa(props) {
    var _this2 = this;

    _classCallCheck(this, DisableTfa);

    var _this = _possibleConstructorReturn(this, (DisableTfa.__proto__ || Object.getPrototypeOf(DisableTfa)).call(this, props));

    _this.disableTfa = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(ev) {
        var confirm;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                ev.preventDefault();
                confirm = window.confirm('This will disable 2FA on your account. Are you sure?');

                if (confirm) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt('return');

              case 4:

                _this.setState({ deleteInProgress: true });
                Router.get().submit({
                  action: _this.props.disableTfaUrl,
                  method: 'POST',
                  data: { csrftoken: _this.props.csrftoken }
                });

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.state = {
      deleteInProgress: false
    };
    return _this;
  }

  _createClass(DisableTfa, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          scope = _props.scope,
          numTfaEnforcedOrgs = _props.numTfaEnforcedOrgs,
          canDelete = _props.canDelete,
          userHasEnforcedTFA = _props.userHasEnforcedTFA;


      return React.createElement(
        'div',
        { className: styles.bodyContainer },
        React.createElement(
          'div',
          null,
          'We strongly recommend using two-factor authentication to secure your account. If you need to disable 2FA, we recommend re-enabling it as soon as possible.'
        ),
        React.createElement(
          'div',
          null,
          canDelete.tfa ? React.createElement(
            'button',
            {
              className: styles.deleteGradientButton,
              disabled: this.state.deleteInProgress,
              onClick: function onClick(ev) {
                return _this3.disableTfa(ev);
              }
            },
            'Disable 2FA'
          ) : React.createElement(TfaEnforcedBanner, {
            scope: scope,
            numTfaEnforcedOrgs: numTfaEnforcedOrgs,
            userHasEnforcedTFA: userHasEnforcedTFA
          })
        )
      );
    }
  }]);

  return DisableTfa;
}(React.PureComponent);

function TfaEnforcedBanner(props) {
  var scope = props.scope,
      numTfaEnforcedOrgs = props.numTfaEnforcedOrgs,
      userHasEnforcedTFA = props.userHasEnforcedTFA;


  var tfaEnforcementMsg = void 0;
  if (userHasEnforcedTFA) {
    tfaEnforcementMsg = React.createElement(
      'span',
      { className: styles.bannerText },
      'Two-factor authentication can\'t be disabled because it is enforced on your npm account. Contact',
      ' ',
      React.createElement(
        'a',
        { className: styles.bannerLink, href: 'https://www.npmjs.com/support' },
        'npm support'
      ),
      ' ',
      'for any questions.'
    );
  } else if (numTfaEnforcedOrgs > 0) {
    tfaEnforcementMsg = React.createElement(
      'span',
      { className: styles.bannerText },
      'Two-factor authentication can\'t be disabled because you belong to ',
      numTfaEnforcedOrgs,
      ' organization(s) that require it. Visit your',
      ' ',
      React.createElement(
        'a',
        { className: styles.bannerLink, href: '/~' + scope.parent.name + '?activeTab=orgs' },
        'organization settings page'
      ),
      ' ',
      'to review which organizations require 2FA.'
    );
  } else {
    return null;
  }

  return React.createElement(Banner, { backgroundColor: 'yellow', text: tfaEnforcementMsg });
}

DisableTfa.layout = 'settings';

module.exports = DisableTfa;
  let __hot__
  
  __registry__.register('tfa/tfa-disable', module.exports, __hot__)
  